import { InstallPromptState } from "@/mk2/containers/InstallPrompt/InstallPrompt.reducers";
import { AppState } from "@/mk2/reducers";

export const getInstallPromptState = (state: AppState): InstallPromptState =>
    state.containers.global.installPrompt;
